import { render } from "./InfoKelulusan.vue?vue&type=template&id=4db7ee6e"
import script from "./InfoKelulusan.vue?vue&type=script&lang=js"
export * from "./InfoKelulusan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__